import service from '@/utils/request'

export const upload = (data) => {
  return service({
    url: '/fileUpload/upload',
    method: 'post',
    data: data
  })
}

export const uploadGI = (data) => {
  return service({
    url: '/fileUpload/uploadGameImage',
    method: 'post',
    data: data
  })
}
